/**
 * Create the store with dynamic reducers
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { middleware as reduxPackMiddleware } from 'redux-pack';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import analytics from 'middlewares/analytics';
import { forbiddenRedirector } from 'middlewares/forbiddenRedirector';
import { createReduxEnhancer } from '@quintoandar/fwp-error-monitoring';

import createReducer from './reducers';

export default function configureStore(initialState = {}, history) {
  const middlewares = [
    thunk,
    reduxPackMiddleware,
    forbiddenRedirector,
    routerMiddleware(history),
  ];

  if (process.env.NODE_ENV === 'production') {
    middlewares.push(analytics);
  }

  /* istanbul ignore next */
  if (process.env.NODE_ENV === 'development') {
    const logger = createLogger({ duration: true });
    middlewares.push(logger);

    middlewares.push(analytics);
  }

  if (process.env.NODE_ENV === 'forno') {
    middlewares.push(analytics);
  }

  const enhancers = [
    applyMiddleware(...middlewares),
    createReduxEnhancer({ attachReduxState: false }),
  ];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle, indent */
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose;
  /* eslint-enable */

  const store = createStore(
    createReducer(),
    initialState,
    composeEnhancers(...enhancers),
  );

  // Extensions
  store.injectedReducers = {}; // Reducer registry

  // Make reducers hot reloadable, see http://mxs.is/googmo
  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.injectedReducers));
      store.dispatch({ type: '@@REDUCER_INJECTED' });
    });
  }

  return store;
}
